import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from '@config/app.config';
import { CustomersService } from '@core/services/customers.service';
import { GeneralsService } from '@core/services/generals.service';
import { TransfersService } from '@core/services/transfers.service';
import { ValidationsService } from '@core/services/validations.service';
import {
  TransfersCustomerListComponent,
} from '@modules/transfers/transfers-customer-list/transfers-customer-list.component';
import { Constants } from '@shared/class/constants.class';
import { TypeIdentify } from '@shared/interfaces/customer';
import { SearchCustomer } from '@shared/interfaces/transfer';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-transfers-customer-filter',
  templateUrl: './transfers-customer-filter.component.html'
})
export class TransfersCustomerFilterComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public transferForm: FormGroup;
  public minDate = moment();
  public maxDate = moment();
  public typesIdentifyList: Array<TypeIdentify> = [];

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public transfersService: TransfersService,
    public customersService: CustomersService
  ) {
    this.minDate = moment().subtract(
      this.appConfig.MIN_DATE.value,
      this.appConfig.MIN_DATE.time
    );
  }

  ngOnInit() {
    this.customersService
      .getTypeIdentify()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.constants.error = false;
          this.constants.loading = false;
          result.data.forEach((element: any) => {
            let typeIdentify: TypeIdentify;
            typeIdentify = { id: element.id, name: element.attributes.name };
            this.typesIdentifyList.push(typeIdentify);
          });
          this.transferForm = new FormGroup({
            typeIdentify: new FormControl('', Validators.required),
            identify: new FormControl('', [
              Validators.required,
              ValidationsService.isInvalidNumberValidator
            ]),
            rol: new FormControl('', Validators.required),
            dateStart: new FormControl(''),
            dateEnd: new FormControl('')
          });
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.transferForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      const value = form.value;
      const formData: SearchCustomer = {
        dateStart: value.dateStart,
        dateEnd: value.dateEnd,
        channel: this.appConfig.CHANNEL,
        identify: value.identify,
        typeIdentify: value.typeIdentify,
        rol: value.rol,
        user: this.generalsService.getUserName(),
        page: 0
      };

      this.transfersService
        .getItemSearch(formData)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            loading.close();

            if (!result.data || result.data.length <= 0) {
              this.generalsService.notification(
                this.appConfig.NOTIFICATION.info,
                this.appConfig.LANG.customers.noCustomer
              );
            } else {
              this.generalsService.modal(
                TransfersCustomerListComponent,
                { form: formData, transfers: result },
                'mat-modal-big'
              );
            }
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }

  validatorDate() {
    const form = this.transferForm,
      controlDateStart = form.controls['dateStart'],
      controlDateEnd = form.controls['dateEnd'],
      start = controlDateStart.value,
      end = controlDateEnd.value;

    if (!!start || !!end) {
      form.setValidators([ValidationsService.validateRangeDateValue]);
      form.updateValueAndValidity();
      controlDateStart.setValidators([
        Validators.required,
        ValidationsService.isMinorThanToday,
        ValidationsService.isMinorThanMinimumDate
      ]);
      controlDateStart.updateValueAndValidity();
      controlDateEnd.setValidators([
        Validators.required,
        ValidationsService.isMinorThanToday,
        ValidationsService.isMinorThanMinimumDate
      ]);
      controlDateEnd.updateValueAndValidity();
    } else {
      form.setValidators([]);
      form.updateValueAndValidity();
      controlDateStart.setValidators([]);
      controlDateStart.updateValueAndValidity();
      controlDateEnd.setValidators([]);
      controlDateEnd.updateValueAndValidity();
    }
  }
}
